import eventBus, { CommonEventBus } from "@common/events/common-event-bus"

export type ModuleRegisterContext = {
  eventBus: CommonEventBus
}

export type ModuleRegisterFn = (context: ModuleRegisterContext) => void

const registerModule = (moduleRegister: ModuleRegisterFn) => {
  const sharedContext: ModuleRegisterContext = {
    eventBus: eventBus
  }

  moduleRegister(sharedContext)
}

export default registerModule
